import React from 'react';
import './TableShimmer.css';

const TableShimmer = ({ rows = 5, columns = 4 }) => {
  return (
    <div className="card table-card-container shimmer-container">
      <div className="card-header table-card-header d-flex justify-content-between align-items-center">
        <div className="shimmer shimmer-title" style={{ width: '200px', height: '24px' }}></div>
        <div className="shimmer shimmer-button" style={{ width: '150px', height: '38px' }}></div>
      </div>
      
      <div className="card-body table-card-body">
        <div className="table-header-container mb-3">
          <div className="search-container">
            <div className="shimmer shimmer-search" style={{ width: '300px', height: '38px' }}></div>
          </div>
        </div>

        <div className="table-responsive-container">
          <table className="table">
            <thead>
              <tr>
                {Array.from({ length: columns }).map((_, index) => (
                  <th key={index}>
                    <div className="shimmer shimmer-header" style={{ width: '100px', height: '20px' }}></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: rows }).map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {Array.from({ length: columns }).map((_, colIndex) => (
                    <td key={colIndex}>
                      <div className="shimmer shimmer-cell" style={{ width: '90%', height: '20px' }}></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default TableShimmer;